/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getClientDireccionesEnvio: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.client_id + '/envios', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createClientDireccionesEnvio: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/envios', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteClientDireccionesEnvio: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('clients/' + data.cliente_id + '/envios/' + data.direccion_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClientDireccionesEnvio: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('clients/' + data.cliente_id + '/envios/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    setDefaultDireccionEnvio: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/envios/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClientDireccionesEnvioSelect: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.client_id + '/envios/select', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ClientDireccionesEnvioModule.js